import React, { useContext } from 'react';
import { PermissionsResponse } from '../types';
import { Permission } from '../models/Permissions';

export const PermissionsContext = React.createContext<PermissionsResponse>({ permissions: [] });

export const useHasPermissions = (requiredPermissions: Permission[]): boolean => {
  const userPermissions = useContext(PermissionsContext);
  return requiredPermissions.filter((x) => userPermissions.permissions.indexOf(x) === -1).length === 0;
};

interface RequiredPermissionProps {
  permissions: Permission[];
  alt?: React.ReactElement;
}

export const RequiredPermissions: React.FC<RequiredPermissionProps> = ({ children, permissions, alt }) => {
  return useHasPermissions(permissions) ? <>{children}</> : alt || null;
};
